module.exports = __webpack_public_path__ + "static/media/flower_seller6.1307a9ef.wav";